"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "srh__department-toggle flex h-[3.5714285rem] font-medium text-gray-70" };
const vue_i18n_1 = require("vue-i18n");
const ToggleItem_vue_1 = __importDefault(require("./ToggleItem.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'DepartmentToggle',
    setup(__props) {
        const { t } = (0, vue_i18n_1.useI18n)();
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("ul", _hoisted_1, [
                (0, vue_2.createVNode)(ToggleItem_vue_1.default, { "department-type": "damen" }, {
                    default: (0, vue_2.withCtx)(() => [
                        (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(t)("siteWide.searchApp.department.women")), 1)
                    ]),
                    _: 1
                }),
                (0, vue_2.createVNode)(ToggleItem_vue_1.default, { "department-type": "herren" }, {
                    default: (0, vue_2.withCtx)(() => [
                        (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(t)("siteWide.searchApp.department.men")), 1)
                    ]),
                    _: 1
                }),
                (0, vue_2.createVNode)(ToggleItem_vue_1.default, { "department-type": "kinder" }, {
                    default: (0, vue_2.withCtx)(() => [
                        (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(t)("siteWide.searchApp.department.kids")), 1)
                    ]),
                    _: 1
                })
            ]));
        };
    }
});
